import * as Yup from "yup";
export var validationSchema = Yup.object({
    username: Yup.string().required(),
    avatar: Yup.object().notRequired(),
});
